module.exports = __webpack_public_path__ + "static/media/Globe.cfae23bf.svg";